export default __webpack_public_path__ + "static/media/Swimming_16_9.446cce75.png";